import type { Country } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getCountriesRefData(): Promise<Country[]> {
  return requestApiJsonOrThrow<Country[]>('admin/reference-data/countries')
}

export const countriesRefDataQuery = {
  queryKey: ['countries-ref-data'],
  queryFn: () => getCountriesRefData(),
}
